import type { ReactNode } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Logo } from '@/layouts/Sidebar';

const points = ['Leads, follow-ups and clients in one pipeline', 'Tasks, approvals and team workload', 'Employees, attendance and transparent working-time', 'Strict tenant isolation and role-based access'];

export function AuthLayout({ title, subtitle, children, wide }: { title: string; subtitle?: string; children: ReactNode; wide?: boolean }) {
  return (
    <div className="grid min-h-dvh lg:grid-cols-[1fr_minmax(0,560px)]">
      <section className="relative hidden overflow-hidden bg-brand p-12 text-white lg:flex lg:flex-col lg:justify-between">
        <div className="flex items-center gap-2.5">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-white/15 text-xl font-bold">S</span>
          <span className="text-xl font-semibold">StopLord</span>
        </div>
        <div className="max-w-md">
          <h2 className="text-3xl font-semibold leading-tight">One connected workspace for sales, people and work.</h2>
          <ul className="mt-8 space-y-3">
            {points.map((p) => (
              <li key={p} className="flex items-start gap-3 text-white/90"><CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0" />{p}</li>
            ))}
          </ul>
        </div>
        <p className="text-sm text-white/70">© {new Date().getFullYear()} StopLord</p>
      </section>
      <section className="flex items-center justify-center bg-surface px-4 py-10 sm:px-10">
        <div className={wide ? 'w-full max-w-xl' : 'w-full max-w-sm'}>
          <div className="mb-8 lg:hidden"><Logo /></div>
          <h1 className="text-2xl font-semibold tracking-tight text-ink">{title}</h1>
          {subtitle && <p className="mt-1.5 text-sm text-ink-muted">{subtitle}</p>}
          <div className="mt-6">{children}</div>
        </div>
      </section>
    </div>
  );
}
